module.exports = __webpack_public_path__ + "static/img/bank3-1.e31e9e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank/bank3-1.png
// module id = RU/J
// module chunks = 1